export const PAGINATION_LABEL = {
  PREV: 'Prev',
  NEXT: 'Next',
  ELLIPSIS: '...',
};

export const METHOD_NOT_SUPPORTED = 'Method is not supported';

export const HTTP_STATUS = {
  TRUE: 'true',
  FALSE: 'false',
};

export const DEFAULT_LIMIT = 10;

export const DEFAULT_OFFSET = 0;

export const DEFAULT_SHOW_RECORDS = 20;

export const TABLE_SIZE = 20;

export const MAX_RECORDS = 5000;

export const TS_SUMMARY = 'TS List';

export const DATE_DISPLAY_FORMAT = 'M/DD/YYYY, h:mm:ss A';

//export const MAX_FILE_SIZE = 5242880; // 5 MB
//export const MAX_FILE_SIZE_IN_MB = '5MB';
export const MAX_FILE_SIZE = 209715200; // 200 MB
export const MAX_FILE_SIZE_IN_MB = '200MB';

export const MAX_FILE_ALLOWED = 5;

export const DEFAULT_ACCEPT_FILE_EXTENSIONS = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'text/plain': ['.txt'],
  'application/vnd.ms-outlook': ['.msg'],
  'image/tiff': ['.tif'],
  'text/csv': ['.csv'],
  'application/x-rpt': ['.rpt'],
  'image/bmp': ['.bmp'],
  'image/x-lst': ['.lst'],
};

export const VALID_FILE_EXTENSIONS =
  '.jpg, .png, .xls, .xlsx, .doc, .docx, .csv, .txt, .pdf, .rpt, .tif, .lst';

export const PATTERNS = {
  VALID_NUMBER: /^[0-9]+$/,
  VALID_UPPERCASE: /^[^a-z]*$/,
  SPECIAL_CHAR: /^[^*|<>[\]{}` \\';?/@$#&+=:".,!%^~]*$/,
  FILE_NAME: /^[^*|<>[\]{}`\\:"' ;,?/+=@$#%&!^~]{0,100}$/,
};

export const ERROR_MSGS = {
  REQUIRED: (field: string) => `Please input ${field}`,
  FILE_UPLOAD_REQUIRED: 'Please upload a file',
  MUST_SELECT: 'Please select at least one option',
  VALID_UPPERCASE: 'Please use uppercase',
  MAX_LENGTH: (maxChar: string) => `Maximum ${maxChar} chars only allowed`,
  MIN_LENGTH: (minChar: string) => `Minimum ${minChar} chars only allowed`,
  NO_SPECIAL_CHAR:
    "Please do not include blank space and special characters * | < > [ ] { }  ' : ; @ $ & # % ^ ~",
  FILE_SIZE_LIMIT: 'File cannot be larger than 200 MB',
};
